import React from 'react';
import '@/assets/styles/components/button.styles.scss';
import { ButtonProps } from './button.types';

export const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', size = 'medium', disabled = false, loading = false, fullWidth = false, onClick, className = '', ...props }) => {
	const baseClassName = `custom-button ${variant} ${size} ${className}`;
	const computedClassName = `
    ${baseClassName}
    ${disabled ? 'disabled' : ''}
    ${loading ? 'loading' : ''}
    ${fullWidth ? 'full-width' : ''}
  `.trim();

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (!disabled && !loading && onClick) {
			onClick(e);
		}
	};

	return (
		<button
			className={computedClassName}
			onClick={handleClick}
			disabled={disabled || loading}
			{...props}>
			<span className="button-content">
				{loading ? (
					<span className="loading-dots">
						<span />
						<span />
						<span />
					</span>
				) : (
					children
				)}
			</span>
		</button>
	);
};
